import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TitleState {
  name: string | null;
}

const initialState: TitleState = {
  name: null,
};

export const titleSlice = createSlice({
  name: "title",
  initialState,
  reducers: {
    setTitleName: (state, action: PayloadAction<string | null>) => {
      state.name = action.payload;
    },
  },
});

export const { setTitleName } = titleSlice.actions;
export const selectTitleName = (state: { title: TitleState }) => state.title.name;
export const titleReducer = titleSlice.reducer;
